import styles from './Spinner.module.scss';

export default function Spinner({size, white}) {
  return (
    <div 
      className={styles.spinner} 
      style={{'fontSize': `${size}px` ?? null, 'borderColor': white ? '#fff' : null }} 
    />
  );
}